import { useQuery } from "@tanstack/react-query";
import { getTargetareSnapshoturi } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareSnapshoturi() {
  return useQuery({
    queryKey: queryKeys.targetare.snapshoturi(),
    queryFn: getTargetareSnapshoturi,
    select: (response) => response.data,
    staleTime: 1000 * 30,
    retry: 1,
  });
}
